import { Button } from 'components/Button/Button'
import styles from './LoginContent.module.scss'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'redux/hooks'
import { updateAccount } from 'redux/rootSlice/rootSlice'
import { Attention } from 'components/Attention/Attention'
import React from 'react'

type Props = {}

export function LoginContent(props: Props) {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [isReqCancel, setIsReqCancel] = React.useState(false)

    function navigateToSignUp() {
        navigate('/signup')
    }

    function connectMetamask() {
        const { ethereum } = window

        if (ethereum) {
            ethereum.request({ method: 'eth_requestAccounts' })
                .then((accounts: string[]) => {
                    if (accounts.length > 0) {
                        dispatch(updateAccount(accounts[0]))
                        navigate('/request')
                    }
                })
                .catch((error: { code: number, message: string }) => {
                    if (error.code === 4001) {
                        // Пользователь отклонил запрос
                        console.log("User rejected the request.")
                        setIsReqCancel(true)
                    } else {
                        // Другие ошибки
                        alert("Please install MetaMask!")
                        console.error("There was an error!", error);
                    }
                });

        } else {
            alert("Please install MetaMask!")
            console.log("Please install MetaMask!");
        }
    }

    return (
        <div className={styles['wrapper']}>
            <div className={styles['title']}>
                Welcome
                <br />
                back
            </div>
            <div className={styles['buttons']}>
                <Button
                    size='m'
                    type='dark'
                    iconName='google'
                    onClick={() => { }}
                >
                    Continue with Google
                </Button>
                <Button
                    size='m'
                    type='dark'
                    iconName='metamask'
                    onClick={connectMetamask}
                >
                    Continue with Metamask
                </Button>
                {isReqCancel && (
                    <div className={styles['cancel-request']}>
                        <Attention color='red'>
                            You cancelled wallet connection. Please approve in Metamask
                        </Attention>
                    </div>
                )}
            </div>
            <div className={styles['help']}>
                <span>New to Drizzle? </span>
                <span
                    className={styles['help__signup']}
                    onClick={navigateToSignUp}>
                    Sign up here
                </span>
            </div>
        </div>
    );
}

